var render = function render(){var _vm=this,_c=_vm._self._c;return _c('aside',{staticClass:"memory",class:_vm.memory.tone || 'subtle'},[_c('v-icon',[_vm._v(_vm._s(_vm.memory.icon || 'mdi-bookmark-outline'))]),_c('div',[(_vm.memory.title)?_c('h3',[_vm._v(_vm._s(_vm.memory.title))]):_vm._e(),_c('p',[_vm._v(_vm._s(_vm.memory.text))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }